import { render, staticRenderFns } from "./invReport.vue?vue&type=template&id=774f216a&scoped=true&"
import script from "./invReport.vue?vue&type=script&lang=js&"
export * from "./invReport.vue?vue&type=script&lang=js&"
import style0 from "./invReport.vue?vue&type=style&index=0&id=774f216a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f216a",
  null
  
)

export default component.exports